export default __webpack_public_path__ + "static/media/service3.cde56a03.png";